import { UnknownError, UUID } from 'symbols';
import { TemplateExpectBackend } from '../../../pdf-templates/symbols';
import { TemplateGraphQLModel } from '../../../symbols';
import { ContractModel, ContractModelExpectBackend } from '../../symbols';

export class CreateContractTemplate {
  static type = '[contractManage] CreateContractTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}

export class UpdateContractTemplate {
  static type = '[contractManage] UpdateContractTemplate';

  constructor(public template: TemplateGraphQLModel, public id: UUID) {
  }
}

export class DeleteContractTemplate {
  static type = '[contractManage] DeleteContractTemplate';

  constructor(public id: UUID) {
  }
}

export class UpdateContractTemplateSuccess {
  static type = '[contractManage] UpdateContractTemplateSuccess';
}

export class UpdateContractTemplateFail {
  static type = '[contractManage] UpdateContractTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetContractTemplateList {
  static readonly type = '[contractManage] GetContractTemplateList';
}

export class GetContractById {
  static type = '[contractManage] GetContractById';

  constructor(public id: UUID) {
  }
}

export class GetContractByIdSuccess {
  static type = '[contractManage] GetContractByIdSuccess';

  constructor(public contract: ContractModel) {
  }
}

export class GetContractByIdFail {
  static type = '[contractManage] GetContractByIdFail';

  constructor(public error: unknown) {
  }
}

export class SetCurrentContractId {
  static type = '[contractManage] SetCurrentContractId';

  constructor(public id: UUID) {
  }
}


export class UpdateLocalContract {
  static type = '[contractManage] UpdateLocalContract';

  constructor(public contract: ContractModel) {
  }
}

export class DeleteLocalContract {
  static type = '[contractManage] DeleteLocalContract';

  constructor(public id: UUID) {
  }
}


export class UpdateContract {
  static type = '[contractManage] UpdateContract';

  constructor(public id: UUID, public contract: ContractModelExpectBackend, public force: boolean) {
  }
}

export class UpdateContractSuccess {
  static type = '[contractManage] UpdateContractSuccess';

  constructor(public contract: ContractModel) {
  }
}

export class UpdateContractFail {
  static type = '[contractManage] UpdateContractFail';

  constructor(public error: UnknownError) {
  }
}

export class CreateContract {
  static type = '[contractManage] CreateContract';

  constructor(public contract: ContractModelExpectBackend) {
  }
}

export class CreateContractSuccess {
  static type = '[contractManage] CreateContractSuccess';

  constructor(public contract: ContractModel) {
  }
}

export class CreateContractFail {
  static type = '[contractManage] CreateContractFail';

  constructor(public error: UnknownError) {
  }
}

export class CreatedContractByWS {
  static type = '[contractList] CreatedContractByWS';

  constructor(public contract: ContractModel) {
  }
}

export class UpdatedContractByWS {
  static type = '[contractList] UpdatedContractByWS';

  constructor(public contract: ContractModel) {
  }
}
